import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import LandingLayout from "../pages/LandingLayout/LandingLayout";
import RegistrationLayout from "../pages/RegistrationLayout/RegistrationLayout";
import Register from "../components/Registration/Register";
import AuthenticationLayout from "../pages/AuthenticationLayout/AuthenticationLayout";
import Login from "../components/Login/Login";
import OtpValidation from "../components/Login/OtpValidation";
import { useAuth } from "../context/AuthProvider";
import { UserService } from "../services/UserService";
import { routePaths } from "../constants/routePaths";
import ClinicManagement from "../components/UserManagement/ClinicManagement";
import SetPassword from "../components/Registration/SetPassword";
import ProtectedRoutesConfig from "./protectedRoutesConfig";
import { Roles } from "../constants/data/Roles";
import { ClinicUserManagement } from "../components/UserManagement/ClinicDetails/ClinicUserManagement/ClinicUserManagement";

import { useEffect, useState } from "react";
import CommunicationLogs from "../components/CommunicationLogs/CommunicationLogs";

const RoutesConfig = () => {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [history, setHistory] = useState<string[]>([]);
  const isLoggedIn = auth?.isLoggedIn || UserService.isLoggedIn;

  useEffect(() => {
    setHistory((prevHistory) => [...prevHistory, location.pathname]);
  }, [location]);

  useEffect(() => {
    if (isLoggedIn === "true") {
      if (history[0]?.includes("reporting")) {
        navigate(history[0], { replace: true });
      }
      setHistory([]);
    }
  }, [isLoggedIn, navigate]);

  return (
    <Routes>
      {auth?.isLoggedIn === "true" || UserService.isLoggedIn === "true" ? (
        <Route
          element={
            <ProtectedRoutesConfig
              element={<LandingLayout />}
            ></ProtectedRoutesConfig>
          }
        >
          <Route
            path={routePaths.clinicManagement}
            element={
              <ProtectedRoutesConfig
                element={<ClinicManagement />}
              ></ProtectedRoutesConfig>
            }
          ></Route>
          <Route
            path={routePaths.clinicDetails}
            element={
              <ProtectedRoutesConfig
                element={<ClinicUserManagement />}
              ></ProtectedRoutesConfig>
            }
          ></Route>
          <Route
            path={routePaths.reporting}
            element={
              <ProtectedRoutesConfig
                element={<ClinicUserManagement />}
              ></ProtectedRoutesConfig>
            }
          ></Route>
          <Route
            path={routePaths.communicationLogs}
            element={
              <ProtectedRoutesConfig
                element={
                  auth?.authClaims?.role === Roles.superUser ? (
                    <Navigate
                      to={`${routePaths.communicationLogs}/0`}
                      replace
                    />
                  ) : (
                    <Navigate to={routePaths.base} />
                  )
                }
              ></ProtectedRoutesConfig>
            }
          />
          <Route
            path={`${routePaths.communicationLogs}/:tabId`}
            element={
              <ProtectedRoutesConfig
                element={
                  auth?.authClaims?.role === Roles.superUser ? (
                    <CommunicationLogs />
                  ) : (
                    <Navigate to={routePaths.base} />
                  )
                }
              />
            }
          />
          <Route
            path={routePaths.base}
            element={
              <ProtectedRoutesConfig
                element={<ClinicManagement />}
              ></ProtectedRoutesConfig>
            }
          />

          <Route
            path={routePaths.wild}
            element={
              <ProtectedRoutesConfig
                element={<Navigate to={routePaths.clinicManagement} />}
              ></ProtectedRoutesConfig>
            }
          />
        </Route>
      ) : (
        <>
          <Route element={<AuthenticationLayout />}>
            <Route path={routePaths.otp} element={<OtpValidation />} />
            <Route path={routePaths.setPassword} element={<SetPassword />} />
            <Route path={routePaths.login} element={<Login />} />
            <Route
              path={routePaths.base}
              element={<Navigate to={routePaths.login} />}
            />
            <Route
              path={routePaths.wild}
              element={<Navigate to={routePaths.login} />}
            />
          </Route>
        </>
      )}
      <Route element={<RegistrationLayout />}>
        <Route path={routePaths.register} element={<Register />} />
      </Route>
    </Routes>
  );
};

export default RoutesConfig;
